<template>
    <div v-html="customHtml">
    </div>
</template>

<script>
    export default {
        props: {
            customTemplate: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            customHtml() {
                return this.customTemplate?.customHtml;
            },
        },
        mounted() {
            let customCode = new Function(this.customTemplate?.customJs);
            customCode();
        },
    };
</script>